/** Tassonomia Adlens per attività locali. Il value è lo slug persistito. */
export const CATEGORIES = [
  { value: 'parrucchiere-beauty', label: 'Parrucchieri & Beauty' },
  { value: 'estetica', label: 'Estetica & Benessere' },
  { value: 'ristorazione', label: 'Ristorazione & Bar' },
  { value: 'fitness', label: 'Fitness & Palestre' },
  { value: 'immobiliare', label: 'Immobiliare' },
  { value: 'retail', label: 'Negozi & Retail' },
  { value: 'automotive', label: 'Automotive' },
  { value: 'salute', label: 'Salute & Studi medici' },
  { value: 'formazione', label: 'Formazione & Corsi' },
  { value: 'turismo', label: 'Turismo & Hotel' },
  { value: 'servizi-pro', label: 'Servizi professionali' },
  { value: 'altro', label: 'Altro' },
] as const;

export function categoryLabel(slug: string | null): string | null {
  if (!slug) return null;
  const legacyLabels: Record<string, string> = {
    food: 'Ristorazione & Bar',
    beauty: 'Estetica & Benessere',
    education: 'Formazione & Corsi',
    services: 'Servizi professionali',
  };
  if (legacyLabels[slug]) return legacyLabels[slug];
  return CATEGORIES.find((c) => c.value === slug)?.label ?? slug;
}
